import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { openIntercom } from 'entities/Intercom'

type IPageErrorAlertProps = {
  errorMessage?: string | null
  title?: string
  marginTop?: number
  marginBottom?: number
}

export const PageErrorAlert = observer(
  ({ errorMessage, title, marginTop, marginBottom }: IPageErrorAlertProps) => {
    if (!errorMessage) return null

    return (
      <Alert
        item={{
          type: 'error',
          title,
          desc: errorMessage,
        }}
        actions={[
          {
            variant: 'button',
            type: 'primary',
            text: 'Learn more',
            onClick: () => {
              openIntercom()
            },
          },
        ]}
        marginTop={marginTop}
        marginBottom={marginBottom}
      />
    )
  }
)
